var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlackRgbWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 256.5,
    width: 1012.98,
    xmlSpace: "preserve",
    viewBox: "0 0 1012.98 256.5",
    y: "0px",
    x: "0px",
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style190",
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E01E5A;}\n\t.st2{fill:#36C5F0;}\n\t.st3{fill:#2EB67D;}\n\t.st4{fill:#ECB22E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105.51,-247.5)",
    id: "g228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "m 429.51,449.44 12.58,-29.34 c 13.77,10.18 31.74,15.57 49.7,15.57 13.17,0 21.56,-5.09 21.56,-12.87 -0.3,-21.56 -79.34,-4.79 -79.94,-58.98 -0.3,-27.54 24.25,-48.8 58.99,-48.8 20.66,0 41.32,5.09 55.99,16.77 l -11.75,29.97 c -13.5,-8.66 -30.17,-14.7 -46.03,-14.7 -10.78,0 -17.97,5.09 -17.97,11.68 0.3,21.26 79.94,9.58 80.84,61.38 0,28.14 -23.96,47.9 -58.09,47.9 -25.16,-0.02 -48.21,-6.01 -65.88,-18.58",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "m 915.13,409.47 c -6.27,11.08 -18.16,18.56 -31.8,18.56 -20.17,0 -36.53,-16.35 -36.53,-36.53 0,-20.18 16.35,-36.53 36.53,-36.53 13.64,0 25.53,7.48 31.8,18.56 l 34.96,-19.37 C 937,330.8 912.01,315 883.33,315 c -42.25,0 -76.5,34.25 -76.5,76.5 0,42.25 34.25,76.5 76.5,76.5 28.69,0 53.67,-15.8 66.76,-39.16 z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect196",
    height: 213.67999,
    width: 43.720001,
    className: "st0",
    y: 251.32001,
    x: 571.09003
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon198",
    points: "1010.82,465.01 1010.82,400.98 1062.62,465.01 1118.49,465.01 1052.62,388.95 1113.7,317.99 1060.22,317.99 1010.82,376.98 1010.82,251.32 967.1,251.32 967.1,465.01 ",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "m 744.42,409.76 c -6.29,10.48 -19.46,18.26 -34.13,18.26 -20.17,0 -36.53,-16.35 -36.53,-36.53 0,-20.18 16.36,-36.53 36.53,-36.53 14.67,0 27.84,8.08 34.13,18.86 z m 0,-91.77 v 17.37 C 737.23,323.38 719.57,315 701,315 c -38.33,0 -68.57,33.83 -68.57,76.35 0,42.52 30.24,76.65 68.57,76.65 18.56,0 36.23,-8.38 43.41,-20.36 V 465 h 43.71 V 317.99 Z",
    className: "st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "m 159.51,409.5 c 0,14.91 -12.09,27 -27,27 -14.91,0 -27,-12.09 -27,-27 0,-14.91 12.09,-27 27,-27 h 27 z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "m 173.01,409.5 c 0,-14.91 12.09,-27 27,-27 14.91,0 27,12.09 27,27 V 477 c 0,14.91 -12.09,27 -27,27 -14.91,0 -27,-12.09 -27,-27 z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "m 200.01,301.5 c -14.91,0 -27,-12.09 -27,-27 0,-14.91 12.09,-27 27,-27 14.91,0 27,12.09 27,27 v 27 z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "m 200.01,315 c 14.91,0 27,12.09 27,27 0,14.91 -12.09,27 -27,27 h -67.5 c -14.91,0 -27,-12.09 -27,-27 0,-14.91 12.09,-27 27,-27 z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "m 308.01,342 c 0,-14.91 12.09,-27 27,-27 14.91,0 27,12.09 27,27 0,14.91 -12.09,27 -27,27 h -27 z",
    className: "st3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "m 294.51,342 c 0,14.91 -12.09,27 -27,27 -14.91,0 -27,-12.09 -27,-27 v -67.5 c 0,-14.91 12.09,-27 27,-27 14.91,0 27,12.09 27,27 z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "m 267.51,450 c 14.91,0 27,12.09 27,27 0,14.91 -12.09,27 -27,27 -14.91,0 -27,-12.09 -27,-27 v -27 z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "m 267.51,436.5 c -14.91,0 -27,-12.09 -27,-27 0,-14.91 12.09,-27 27,-27 h 67.5 c 14.91,0 27,12.09 27,27 0,14.91 -12.09,27 -27,27 z",
    className: "st4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackRgbWhite);
export default __webpack_public_path__ + "static/media/Slack_RGB_White.61305282e384dcf40c70ae3774e51710.svg";
export { ForwardRef as ReactComponent };